import { Box, Typography } from "@mui/material";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { icons } from "../../assets";
import AuthLayout from "../../components/authLayout";
import CustomButton from "../../components/customButton";
import TextInput from "../../components/textInput";
import AppLoader from "../../components/appLoader";
import { openSnackAlert } from "../../helper";
import { adminResetPassword } from "../../services/Auth";
const SetNewPassword = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const email = location.state?.email;
  const otp = location.state?.otp;

  console.log(email, otp, "dhakjshksajdhad");

  const [newPassword, setNewPassword] = useState("");
  const [reEnterPassword, setReEnterPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const validatePassword = (password) => {
    const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
    return passwordRegex.test(password);
  };

  const handleSubmit = async () => {
    setErrors({});

    if (!newPassword || !reEnterPassword) {
      setErrors((prev) => ({ ...prev, general: "Both fields are required." }));
      return;
    }

    if (newPassword !== reEnterPassword) {
      setErrors((prev) => ({ ...prev, match: "Passwords do not match." }));
      return;
    }

    if (!validatePassword(newPassword)) {
      setErrors((prev) => ({
        ...prev,
        strength:
          "Password must be at least 8 characters, with a digit and a capital letter.",
      }));
      return;
    }

    try {
      setIsLoading(true);
      const response = await adminResetPassword({
        email,
        otp,
        newPassword,
      });

      if (response?.data?.status === "success") {
        openSnackAlert(response.data.message, "success");
        // let data = response.data.data.admin;
        // dispatch(setUserData(data));
        // localStorage.setItem(
        //   "userData",
        //   JSON.stringify(response.data.data.admin)
        // );
        // localStorage.setItem("token", JSON.stringify(response.data.token));
        navigate("/login");
      } else {
        openSnackAlert(response.data.message, "error");
      }
    } catch (error) {
      openSnackAlert(error?.message, "error");
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <AuthLayout>
      <AppLoader isVisible={isLoading} />
      <Box
        p={6}
        py={4}
        mt={3}
        width={{ xs: 400, sm: 520 }}
        bgcolor="#fff"
        borderRadius="16px"
        boxShadow="0 4px 30px rgba(0, 0, 0, 0.1)"
      >
        <Box
          sx={{
            textDecoration: "none",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <img
            src={icons.applogo}
            alt="Capacity&Care"
            style={{ height: "60px" }}
          />

        </Box>
        <Typography textAlign={"center"} my={3} fontSize={14} fontWeight={600}>
          SET NEW PASSWORD
        </Typography>

        <Typography variant="label" mb={2}>
          Enter your new password
        </Typography>
        <TextInput
          name="newPassword"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          placeholder="New Password"
          sx={{
            borderRadius: "22px",
            my: 1,
            mb: 2,
          }}
          helperText={errors.strength}
          error={errors.strength}
        />

        <Typography variant="label" mb={2}>
          Confirm your new password
        </Typography>
        <TextInput
          name="confirmPassword"
          value={reEnterPassword}
          onChange={(e) => setReEnterPassword(e.target.value)}
          placeholder="Confirm Password"
          sx={{
            borderRadius: "22px",
            my: 1,
            mb: 2,
          }}
          helperText={errors.match}
          error={errors.match}
        />

        <CustomButton
          width={"100%"}
          btnLabel={"Reset Password & Login"}
          variant="authbutton"
          borderRadius="28px"
          btnTextColor={"#ffff"}
          height={"50px"}
          handlePressBtn={handleSubmit}
        />


      </Box>


    </AuthLayout>
  );
};

export default SetNewPassword;
